/**
 * SuburbSchoolPicker
 * 
 * @Author: Focci
 * @Date: 2024-04-25 13:58:21
 * @Last Modified by: Focci
 * @Last Modified time: 2024-04-25 13:58:21
 */

import { Button } from '@comp/material'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import ZoneAndSchool from '../zone-school/index'

export default function SuburbSchoolPicker({
  onChange = () => {}
}) {
  const ts = useTranslations('search')
  const [open, setOpen] = useState(false)

  const handleSubmit = useCallback((data) => {
    setOpen(false)
    onChange(data)
  }, [onChange])

  return (
    <>
      <div className="bg-white z-1 px-2">
        <Button 
          variant="outlined"
          onClick={() => setOpen(true)}
        >
          {`${ts('district')}/${ts('schools')}`}
        </Button>
      </div>
      {open && (
        <ZoneAndSchool
          open={open}
          onClose={() => setOpen(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  )
}

// SuburbSchoolPicker.propTypes = {
//   className: PropTypes.string,
// }
